import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import StatusModal from "@components/StatusModal/StatusModal";

const SuccessPage = () => {
  return (
    <StatusModal
      paymentStatus="Payment Successful"
      statusDescription="Your payment has been successfully processed."
      icon={<CheckCircleIcon sx={{ color: "#4caf50", fontSize: 50 }} />}
    />
  );
};

export default SuccessPage;
